import { post } from './';

const postContactForm = (query) => post('/contact-us', query);

const contactApi = {
  postContactForm,
};

export default contactApi;
